import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgPackagingGlyphSecondary(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M22.17 30.52c-.54 0-.97.43-.97.97s.43.97.97.97.97-.43.97-.97a.97.97 0 0 0-.97-.97ZM25.57 30.52c-.54 0-.97.43-.97.97s.43.97.97.97.97-.43.97-.97-.43-.97-.97-.97ZM23.87 27.19c-.54 0-.97.43-.97.97s.43.97.97.97.97-.43.97-.97a.97.97 0 0 0-.97-.97ZM23.87 33.84c-.54 0-.97.43-.97.97s.43.97.97.97.97-.43.97-.97a.97.97 0 0 0-.97-.97ZM20.41 33.84c-.54 0-.97.43-.97.97s.43.97.97.97.97-.43.97-.97-.43-.97-.97-.97ZM27.33 35.78c.54 0 .97-.43.97-.97s-.43-.97-.97-.97-.97.43-.97.97.43.97.97.97Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M34.04 8H13.75c-.41 0-.75.34-.75.75v30.5c0 .41.34.75.75.75s.75-.34.75-.75V9.5h18.79v29.75c0 .41.34.75.75.75s.75-.34.75-.75V8.75c0-.41-.33-.75-.75-.75Z",
    fill: "currentColor"
  }), jsx("path", {
    d: "M31.36 10.76c-.41 0-.75.34-.75.75V38.5H17.18V11.51c0-.41-.34-.75-.75-.75s-.75.34-.75.75v27.74c0 .41.34.75.75.75h14.92c.41 0 .75-.34.75-.75V11.51a.74.74 0 0 0-.74-.75Z",
    fill: "currentColor"
  }));
}

export { SvgPackagingGlyphSecondary as default };
